export function EmptyFunction() {}

export const DEFAULT_JOBS_FEEED = {
  PATHNAME: "/jobs/matching-my-filters",
  PAGENUMBER: "1",
  BREAKDOWN_ID: "",
  IS_BACK_TO_JOBS_FEED: false,
};
